import React from 'react'
import ClassNames from 'classnames'

import { TaskBlockStyle } from './styled'
import { formatNumberWithComma } from '../../helpers'

export class TaskBlock extends React.PureComponent {
  render() {
    const { className, children, task } = this.props

    return (
      <TaskBlockStyle
        {...this.props}
        className={ClassNames('task-block', className)}
      >
        <div className="task-number">{formatNumberWithComma(task)}</div>
        <div className="task-text">{children}</div>
      </TaskBlockStyle>
    )
  }
}
